import { LegalPage } from "@/components/LegalPage";

const sections = [
  {
    h: "Introduction",
    p: [
      "Elikya Technology, Inc. (\"Elikya\", \"we\", \"us\" or \"our\") respects your privacy and is committed to protecting the personal information you share with us. This Privacy Policy explains what information we collect, how we use it, and the choices you have.",
      "This policy applies to our website, dashboards and the payment services we provide to businesses and their customers.",
    ],
  },
  {
    h: "Information We Collect",
    p: ["We collect information in the following ways:"],
    list: [
      "Information you provide — such as your name, work email, business name, payout region and messages you send us.",
      "Transaction information — payment amounts, methods, status and timestamps processed through our platform on behalf of merchants.",
      "Technical information — device, browser, IP address and usage data collected automatically to keep the service secure and reliable.",
    ],
  },
  {
    h: "How We Use Your Information",
    p: ["We use the information we collect to:"],
    list: [
      "Provide, operate and improve our payment services.",
      "Process transactions, settlements and reconciliation accurately.",
      "Detect, prevent and investigate fraud and security incidents.",
      "Communicate with you about your account, support requests and service updates.",
      "Comply with legal, regulatory and audit obligations.",
    ],
  },
  {
    h: "Sharing and Disclosure",
    p: [
      "We do not sell your personal information. We share information only with payment partners, banks and mobile money providers as needed to complete transactions, with service providers who work on our behalf under confidentiality obligations, and where required by law or to protect our rights and users.",
    ],
  },
  {
    h: "Data Security",
    p: [
      "We apply bank-grade safeguards including encryption in transit and at rest, tokenisation of sensitive payment data, continuous monitoring and strict access controls. Our architecture is designed to meet PCI DSS requirements. No method of transmission or storage is ever completely secure, but we work hard to protect your information.",
    ],
  },
  {
    h: "Data Retention",
    p: [
      "We retain personal and transaction information for as long as your account is active and as needed to provide the service, comply with our legal obligations, resolve disputes and enforce our agreements. When information is no longer needed, we securely delete or anonymise it.",
    ],
  },
  {
    h: "International Transfers",
    p: [
      "Elikya is incorporated in Newark, Delaware, United States, and operates regional hubs in South Africa and the Democratic Republic of the Congo. Your information may be processed in these and other locations. Where we transfer data across borders, we apply appropriate safeguards consistent with applicable law.",
    ],
  },
  {
    h: "Your Rights",
    p: [
      "Depending on your location, you may have the right to access, correct, delete or restrict the processing of your personal information, and to object to certain uses. To exercise these rights, contact us at hello@elikya.tech and we will respond within a reasonable timeframe.",
    ],
  },
  {
    h: "Cookies",
    p: [
      "We use cookies and similar technologies to keep you signed in, remember your preferences, and understand how the service is used so we can improve it. You can control cookies through your browser settings; disabling some cookies may affect functionality.",
    ],
  },
  {
    h: "Children's Privacy",
    p: [
      "Our services are intended for businesses and adults. We do not knowingly collect personal information from children. If you believe a child has provided us information, please contact us so we can remove it.",
    ],
  },
  {
    h: "Changes to This Policy",
    p: [
      "We may update this Privacy Policy from time to time. When we make material changes, we will update the \"Last updated\" date above and, where appropriate, provide additional notice. Your continued use of the service after changes take effect constitutes acceptance of the updated policy.",
    ],
  },
  {
    h: "Contact Us",
    p: [
      "If you have questions or requests regarding this Privacy Policy or your personal information, contact us at hello@elikya.tech. Elikya Technology, Inc., Newark, Delaware, United States.",
    ],
  },
];

const Privacy = () => (
  <LegalPage
    title="Privacy Policy"
    updated="January 1, 2026"
    description="How Elikya Technology collects, uses, shares and protects your information across our payment platform."
    path="/privacy"
    intro="Your trust matters to us. This Privacy Policy describes how Elikya Technology handles personal and transaction information when you use our website and payment services."
    sections={sections}
  />
);

export default Privacy;
